import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { Children, useEffect, useRef } from 'react';
import { useDialogContext } from './useDialogContext';
/** A footer that renders 1-3 buttons in the order given, to be used within a `<Dialog />` component */
const DialogFooter = ({ children, showDivider, ...rest }) => {
    const footerRef = useRef(null);
    const { setFooterRef } = useDialogContext();
    const dataAttributes = useDataAttributes(rest);
    useEffect(() => {
        setFooterRef(footerRef);
    }, [setFooterRef, footerRef]);
    const numberOfChildren = Children.count(children);
    const classes = buildClassName(`bb-dialog__footer bb-dialog__footer--${numberOfChildren} shrink-0`, {
        'bb-dialog__footer--with-divider': showDivider,
    });
    if (numberOfChildren !== 3) {
        return (_jsx("footer", { className: classes, ref: footerRef, ...dataAttributes, children: children }));
    }
    const childrenArray = Children.toArray(children);
    return (_jsxs("footer", { className: classes, ref: footerRef, ...dataAttributes, children: [childrenArray[0], _jsxs("div", { className: "flex items-center", children: [childrenArray[1], childrenArray[2]] })] }));
};
export default DialogFooter;
//# sourceMappingURL=DialogFooter.js.map